import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@metarouter-private/mr-mui';

export default function UploadModalActions({ onCancel, onConfirm, disabled }) {
  return (
    <>
      <Button onClick={onCancel} color="secondary" variant="outlined" data-test-id="upload-modal-cancel-button">
        Cancel
      </Button>
      <Button onClick={onConfirm} variant="contained" disabled={disabled} data-test-id="upload-modal-confirm-button">
        Upload
      </Button>
    </>
  );
}

UploadModalActions.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
